import { computed } from 'vue';
import { weeks } from '@/stores/Rooms';
import __ from '@/libraries/Translation';

export const currentWeekDays = computed(() => {
  const collect = [];
  weeks.value.forEach((week) => {
    if (week.selected) {
      for (let i = 0; i < 7; i++) {
        const date = new Date(week.start);
        date.setDate(date.getDate() + i);
        let month = date.getMonth() + 1;
        if (month < 10) {
          month = `0${month}`;
        }
        let day = date.getDate();
        if (day < 10) {
          day = `0${day}`;
        }

        collect.push({
          shortName: __(`day_name_short_${i + 1}`),
          date: `${day}.${month}`
        });
      }
    }
  });

  return collect;
});
